import React from "react";
import clsx from "clsx";

import { FaqCategoryItem } from "../../types";
import styles from "../FaqCategoryItems.module.scss";

const Answer = () => (
  <div className={styles.answer}>
    <div className={styles.head}>
      <span className={styles.icon}>A</span>
      <p className={styles.text}>以下の手順で設定を行ってください。</p>
    </div>
    <div>
      <ul className={clsx(styles.list, styles.number)}>
        <li className={styles.item}>先生画面にログインする</li>
        <li className={styles.item}>
          画面右上に表示されているお名前をクリックし、アカウント設定を開く
        </li>
        <li className={styles.item}>
          「Googleアカウント連携」「Microsoftアカウント連携」のボタンをクリックする
        </li>
      </ul>
      <p className={styles.text}>
        ※連携を解除したい場合は、同じ手順で解除することができます。
      </p>
    </div>
  </div>
);

export const GOOGLE_MICROSOFT_ACCOUNT_LINKING_FAQ: FaqCategoryItem = {
  id: "google-microsoft-account-linking-faq",
  question:
    "先生画面にログインする際、Googleアカウント／Microsoftアカウントを使用したい",
  Answer,
};
